<template>
  <div ref="imageContainer" class="image-container">
    <img 
      ref="image"
      src="@/assets/30935_11zon.webp"
      alt="Imagen destacada"
      class="cover-image"
    >
    
    <!-- Capa de oscurecimiento animada (SOLO ABAJO) -->
    <div ref="overlayRef" class="overlay"></div>
    
    <!-- Texto con distribución limpia sin <br> forzados -->
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        With love,<br>
        <span class="nombre-firma">Angie Urbina</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const overlayRef = ref(null)
    const imageContainer = ref(null)
    let ctx = null

    onMounted(() => {
      ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 85%', // Dispara justo cuando el elemento asoma en la pantalla del celular
            toggleActions: 'play none none none',
            once: true
          },
          defaults: { ease: 'power3.out' }
        })

        // 1. Entrada Editorial de la Imagen (Zoom + Blur + Slide)
        tl.fromTo(
          image.value,
          {
            opacity: 0,
            scale: 1.15,
            y: 40,
            filter: 'blur(10px)'
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.6
          }
        )

        // 2. Oscurecimiento progresivo inferior para contraste
        .fromTo(
          overlayRef.value,
          { opacity: 0 },
          { opacity: 1, duration: 1 },
          '-=1.0'
        )

        // 3. Entrada de la Firma Elegante
        .fromTo(
          textRef.value,
          {
            opacity: 0,
            y: 30,
            filter: 'blur(6px)'
          },
          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.2
          },
          '-=0.6'
        )
      }, imageContainer.value)

      // Refresco para asegurar sincronización en navegadores móviles
      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 300)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { 
      textRef, 
      image, 
      overlayRef, 
      imageContainer 
    }
  }
}
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 590px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform, filter, opacity;
}

/* Degradado que oscurece suavemente la parte inferior */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 40%,
    rgba(0, 0, 0, 0.65) 100%
  );
  z-index: 2;
  will-change: opacity;
}

.text-overlay {
  position: relative;
  z-index: 10;
  width: 100%;
  text-align: center;
  color: #ffffff;
  padding: 0 20px 32px;
  box-sizing: border-box;
  will-change: transform, opacity, filter;
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 2px;
  line-height: 1.4;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.nombre-firma {
  display: block;
  margin-top: 8px;
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 52px;
  color: #ffffff;
  line-height: 1.1;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

@media (max-width: 480px) {
  .image-container {
    height: 520px;
  }
  .nombre-firma {
    font-size: 44px;
  }
}
</style>